import { usStates } from "../data/counties";

/**
 * Convert state abbreviation to full state name
 * @param {string} stateAbbr - State abbreviation (e.g., "FL")
 * @returns {string} Full state name (e.g., "Florida") or original value if not found
 */
export const convertStateAbbreviationToFullName = (stateAbbr) => {
  if (!stateAbbr) return "";

  // If it's already a full state name, return as is
  const fullStateNames = usStates.map((state) => state.name);
  if (fullStateNames.includes(stateAbbr)) {
    return stateAbbr;
  }

  // Convert abbreviation to full name
  const stateObj = usStates.find(
    (state) => state.abbreviation.toUpperCase() === stateAbbr.toUpperCase()
  );

  return stateObj ? stateObj.name : stateAbbr;
};

/**
 * Convert full state name to state abbreviation
 * @param {string} stateName - Full state name (e.g., "Florida")
 * @returns {string} State abbreviation (e.g., "FL") or original value if not found
 */
export const convertStateFullNameToAbbreviation = (stateName) => {
  if (!stateName) return "";

  // If it's already an abbreviation, return as is
  const abbreviations = usStates.map((state) => state.abbreviation);
  if (abbreviations.includes(stateName.toUpperCase())) {
    return stateName.toUpperCase();
  }

  // Convert full name to abbreviation
  const stateObj = usStates.find(
    (state) => state.name.toUpperCase() === stateName.toUpperCase()
  );

  return stateObj ? stateObj.abbreviation : stateName;
};

/**
 * Get state object by abbreviation or name
 * @param {string} stateValue - State abbreviation or full name
 * @returns {object|null} State object with name and abbreviation properties
 */
export const getStateObject = (stateValue) => {
  if (!stateValue) return null;

  // Try to find by abbreviation first
  let stateObj = usStates.find(
    (state) => state.abbreviation.toUpperCase() === stateValue.toUpperCase()
  );

  // If not found, try to find by full name
  if (!stateObj) {
    stateObj = usStates.find(
      (state) => state.name.toUpperCase() === stateValue.toUpperCase()
    );
  }

  return stateObj;
};

export const mergeSelectedCountiesById = (
  selectedCountiesNOC,
  county_cards,
) => {
  return selectedCountiesNOC?.map((selectedCounty) => {
    const countyData = county_cards?.jur_us_fl?.find(
      (c) => c?.id === selectedCounty?.jurisdiction_id,
    );

    return {
      jurisdiction_id: selectedCounty?.jurisdiction_id,
      defaults: selectedCounty?.defaults,
      added_name: selectedCounty?.added_name,
      added_email: selectedCounty?.added_email,
      locked: selectedCounty?.locked,
      ...countyData,
    };
  });
};
